import { render, staticRenderFns } from "./AllBooks.vue?vue&type=template&id=423e56b1&scoped=true&"
import script from "./AllBooks.vue?vue&type=script&lang=js&"
export * from "./AllBooks.vue?vue&type=script&lang=js&"
import style0 from "./AllBooks.vue?vue&type=style&index=0&id=423e56b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e56b1",
  null
  
)

component.options.__file = "AllBooks.vue"
export default component.exports